import { FormFieldHeader } from 'app/form-fields/common/register/form-field-header/form-field-header';

import { MultilineLineInputHeaderColumn } from './multi-line-input-header-column';

export class MultiLineInputHeader extends FormFieldHeader {
  constructor(item) {
    super(item);

    const column = new MultilineLineInputHeaderColumn(item);
    this.columns = [column];

    this.filter = column.filter;
  }
}
